export default __webpack_public_path__ + "static/media/p.8f4c4fd4.mp4";